import { useState, useMemo } from "react";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";

const ACCENT = "#4FA3D9";

// A light "for grown-ups" gate — a simple arithmetic challenge.
export const ParentGate = ({ onPass, onCancel }) => {
  const [a] = useState(() => 6 + Math.floor(Math.random() * 8));
  const [b] = useState(() => 4 + Math.floor(Math.random() * 8));
  const [val, setVal] = useState("");
  const [error, setError] = useState(false);
  const answer = useMemo(() => a + b, [a, b]);

  const submit = () => {
    if (parseInt(val, 10) === answer) onPass();
    else { setError(true); setVal(""); }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      className="mx-auto max-w-md rounded-3xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-sm"
      data-testid="parent-gate"
    >
      <div className="mb-4 flex items-center gap-2.5" style={{ color: ACCENT }}>
        <Lock size={16} />
        <span className="text-xs font-semibold uppercase tracking-[0.2em]">For grown-ups</span>
      </div>
      <p className="mb-6 text-base leading-relaxed text-white/70">
        To open the private Guardian History, please answer this quick question.
      </p>
      <label className="mb-2 block text-lg font-medium text-white">
        What is {a} + {b}?
      </label>
      <input
        type="number"
        inputMode="numeric"
        value={val}
        onChange={(e) => { setVal(e.target.value); setError(false); }}
        onKeyDown={(e) => e.key === "Enter" && submit()}
        data-testid="parent-gate-input"
        autoFocus
        className="mb-4 w-full rounded-xl border border-white/12 bg-black/30 px-4 py-3 text-lg text-white focus:border-[#4FA3D9] focus:outline-none"
        placeholder="Type your answer"
      />
      {error && (
        <p className="mb-4 text-sm text-red-400/80" data-testid="parent-gate-error">
          That's not quite right — try again.
        </p>
      )}
      <div className="flex gap-3">
        <button
          onClick={onCancel}
          data-testid="parent-gate-cancel"
          className="rounded-full border border-white/15 px-6 py-3 text-sm font-medium text-white/70 transition-colors hover:bg-white/5"
        >
          Cancel
        </button>
        <button
          onClick={submit}
          data-testid="parent-gate-submit"
          className="rounded-full px-7 py-3 text-sm font-semibold uppercase tracking-widest text-white transition-opacity hover:opacity-90"
          style={{ background: ACCENT }}
        >
          Continue
        </button>
      </div>
    </motion.div>
  );
};

export default ParentGate;
